// extracted by mini-css-extract-plugin
export default {"periodSelector":"PeriodSelector_periodSelector__PKMMu","box":"PeriodSelector_box__6ndOe","dropdownWrapper":"PeriodSelector_dropdownWrapper__Zj+9M"};